import { create } from 'zustand';
import { User } from '../types';
import { clearStoredToken } from '../config/api';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  setUser: (user: User) => void;
  logout: () => void;
  loadToken: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  setAuth: (user, token) => {
    set({ user, token, isAuthenticated: true });
  },

  setUser: (user) => set({ user }),

  logout: () => {
    clearStoredToken();
    set({ user: null, token: null, isAuthenticated: false });
  },

  loadToken: () => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    set({ token, isAuthenticated: !!token });
  },
}));
